export enum CourierStatus {
  PENDING = "pending",
  PICKED_UP = "picked_up",
  IN_TRANSIT = "in_transit",
  DELIVERED = "delivered",
  RETURNED = "returned",
  CANCELLED = "cancelled",
}

export const CourierStatusInfo = {
  [CourierStatus.PENDING]: { code: "pending", name: "Pending" },
  [CourierStatus.PICKED_UP]: { code: "picked_up", name: "Picked Up" },
  [CourierStatus.IN_TRANSIT]: { code: "in_transit", name: "In Transit" },
  [CourierStatus.DELIVERED]: { code: "delivered", name: "Delivered" },
  [CourierStatus.RETURNED]: { code: "returned", name: "Returned" },
  [CourierStatus.CANCELLED]: { code: "cancelled", name: "Cancelled" },
} as const;

export const getCourierStatusCode = (value: CourierStatus): string =>
  CourierStatusInfo[value].code;
export const getCourierStatusName = (value: CourierStatus): string =>
  CourierStatusInfo[value].name;

export const COURIER_TERMINAL_STATUSES: readonly string[] = [
  CourierStatus.DELIVERED,
  CourierStatus.RETURNED,
  CourierStatus.CANCELLED,
];

export const COURIER_COD_AWAITING_STATUSES: readonly string[] = [
  CourierStatus.PENDING,
  CourierStatus.PICKED_UP,
  CourierStatus.IN_TRANSIT,
  CourierStatus.DELIVERED,
];

export const isCourierStatusTerminal = (status?: string | null): boolean =>
  !!status && COURIER_TERMINAL_STATUSES.includes(status);

export const COURIER_STATUS_TAG_COLORS: Record<string, string> = {
  [CourierStatus.PENDING]: "bg-amber-50 text-amber-700 border-amber-200",
  [CourierStatus.PICKED_UP]: "bg-blue-50 text-blue-700 border-blue-200",
  [CourierStatus.IN_TRANSIT]: "bg-violet-50 text-violet-700 border-violet-200",
  [CourierStatus.DELIVERED]:
    "bg-emerald-50 text-emerald-700 border-emerald-200",
  [CourierStatus.RETURNED]: "bg-rose-50 text-rose-700 border-rose-200",
  [CourierStatus.CANCELLED]: "bg-gray-100 text-gray-600 border-gray-300",
};

export enum CourierFeePayer {
  CUSTOMER = "customer",
  SELLER = "seller",
}
